import React from "react";
import hshape from "../../assets/img/hshape.svg";
import VideoCard from "./VideoCard";
import CountCard from "./CountCard";
const VideoSection = ({ videoData }) => {
  return (
    <section className="section-space vid-sec">
      <div className="container-xl">
        <div className="row">
          <div className="col-lg-12 text-center">
            <div className="main-h">
              <h2 className="m-heading">Endorse Learning Introduction Video</h2>
              <img src={hshape} className="img-fluid " alt="logo" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <VideoCard videoData={videoData} />
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-6">
                <CountCard teamMembers={videoData?.count_1} />
              </div>
              <div className="col-lg-6 col-md-6 col-6">
                <CountCard teamMembers={videoData?.count_2} />
              </div>
              <div className="col-lg-6 col-md-6 col-6">
                <CountCard teamMembers={videoData?.count_3} />
              </div>
              <div className="col-lg-6 col-md-6 col-6">
                <CountCard teamMembers={videoData?.count_4} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
